// extracted by mini-css-extract-plugin
export default {"container":"RestoreHistoryButton-module__container--V88yg","iconButton":"RestoreHistoryButton-module__iconButton--cYpKB","button":"RestoreHistoryButton-module__button--PeZ0J"};